import {
  FETCH_ALL_FLASHCARD_TYPES,
  CREATE_FLASHCARD_TYPE,
  UPDATE_FLASHCARD_TYPE,
  DELETE_FLASHCARD_TYPE,
} from '../constants/actionTypes';

const flashcardTypes = (flashcardTypes = [], action) => {
  switch (action.type) {
    case FETCH_ALL_FLASHCARD_TYPES:
      return action.payload;
    case CREATE_FLASHCARD_TYPE:
      return [...flashcardTypes, action.payload];
    case UPDATE_FLASHCARD_TYPE:
      return flashcardTypes.map((t) =>
        t._id === action.payload._id ? action.payload : t,
      );
    case DELETE_FLASHCARD_TYPE:
      return flashcardTypes.filter((t) => t._id !== action.payload);
    default:
      return flashcardTypes;
  }
};

export default flashcardTypes;
